// NotificationStore.js
import { makeObservable, observable, action } from "mobx";

export type NotificationType = "success" | "error" | "info" | "warning" | "";

class NotificationStore {
  message = "";
  type: NotificationType = "info"; // Default type is "info"
  error = "";
  stackTrace = "";
  statusCode = 0;
  timestamp = "";

  constructor() {
    makeObservable(this, {
      message: observable,
      type: observable,
      error: observable,
      stackTrace: observable,
      statusCode: observable,
      timestamp: observable,
      showMessage: action,
    });
  }

  showMessage(message:any, type:NotificationType, error:any = undefined) {
    this.message = message;
    this.type = type; // Update the type along with the message
    this.error = error?.response?.data?.message || "";
    this.stackTrace = error?.response?.data?.stack || "";
    this.statusCode = error?.response?.data?.statusCode || 0;
    this.timestamp = error?.response?.data?.timestamp || "";
    // console.log("Notification:", message, "Type:", type, "Error:", error);
  }
}

const notificationStore = new NotificationStore();

export default notificationStore;
